<template>
    <v-expansion-panel class="main_menu" v-model="panel" expand v-if="charged">
        <v-expansion-panel-content v-for="(section, index) in displaySections" :key="index">
            <template v-slot:header>
                <div>{{section.name}}</div>
            </template>
            <v-flex class="main_menu__sections layout row wrap">
                <div class="main_menu__section_item lg5 mb-3" v-for="(item_section, index) in section.items" :key="index">
                    <v-list class="main_menu__list_item" :class = "{'main_menu__list_item--inactive_item' : !item_section.active}" v-if="item_section.dropdown">
                        <v-list-group no-action>
                            <template v-slot:activator>
                            <v-list-tile-avatar class="main_menu__list_item--icon_div" :title="item_section.title">
                                <component :is="item_section.component"></component>
                            </v-list-tile-avatar>
                            <v-list-tile :title="item_section.title">
                                <v-list-tile-content>
                                    <v-list-tile-title class="main_menu__section_item--list_title">{{ item_section.title }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item_section.subtitle }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            </template>

                            <v-list-tile
                                v-for="subItem in item_section.sub_items"
                                :key="subItem.title"
                                @click="$router.push({name: subItem.active ? subItem.route : '' })"
                                :title="subItem.title"
                                :class = "{'main_menu__list_item--inactive_item' : !subItem.active}"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                    <v-icon>{{ subItem.action }}</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list-group>
                    </v-list>
                    <v-list v-else class="main_menu__normal_item" :class = "{'main_menu__normal_item--inactive_item' : !item_section.active}">
                        <v-list-tile @click="$router.push({name: item_section.active ? item_section.route : ''})"  :title="item_section.title">
                            <v-list-tile-avatar class="main_menu__normal_item--icon_div">
                                <component :is="item_section.component"></component>
                            </v-list-tile-avatar>

                            <v-list-tile-content class="main_menu__section_item--text">
                                <v-list-tile-title class="main_menu__section_item--title">{{ item_section.title }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ item_section.subtitle }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </div>
            </v-flex>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
    export default {
        data(){
            return{
                charged: false,
                panel: [true, true, true, true, true],
                sub_item_selected: null,
                sections: [
                    {
                        id: 1,
                        name: 'Configuración',
                        items: [
                            {
                                title: 'Zonas/Puertas (Locaciones)',
                                subtitle: '',
                                active: true,
                                action: 'local_activity',
                                component: 'location',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Crear Zona/Puerta',
                                        route: 'location_new',
                                        active: true
                                    },
                                    {
                                        id: 2,
                                        title: 'Editar Zona/Puerta (todos)',
                                        route: 'location',
                                        active: true
                                    },
                                    {
                                        id: 3,
                                        title: '*Crear apartamento "Pagos" (crear inmueble)',
                                        route: 'location',
                                        active: true
                                    }
                                ]
                            },
                            {
                                title: 'Roles de usuarios',
                                subtitle: '',
                                active: true,
                                component: 'user-roles-icon',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Crear nuevo rol',
                                        route: 'user_create_plan',
                                        active: true
                                    },
                                    {
                                        id: 2,
                                        title: 'Lista de usuarios por rol',
                                        route: '',
                                        active: true
                                    },
                                    {
                                        id: 3,
                                        title: 'Editar roles de usuarios',
                                        route: 'user_list_plans',
                                        active: true
                                    }
                                ]
                            },
                            {
                                title: 'Usuarios',
                                subtitle: '',
                                component: 'user-icon',
                                active: true,
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 0,
                                        title: 'Nuevo Usuario',
                                        route: 'new_user',
                                        active: true
                                    },
                                    {
                                        id: 1,
                                        title: 'Importar / actualizar usuarios',
                                        route: 'import_users',
                                        active: true
                                    },
                                    // {
                                    //     id: 2,
                                    //     title: 'Importar / actualizar empleados',
                                    //     route: 'import_employees',
                                    //     active: true
                                    // },
                                    {
                                        id: 2,
                                        title: 'Ver todos',
                                        route: 'users',
                                        active: true
                                    },
                                    {
                                        id: 3,
                                        title: 'Ver activos',
                                        route: 'users_active',
                                        active: true
                                    },
                                    {
                                        id: 4,
                                        title: 'Editar información de usuario',
                                        route: 'edit_user',
                                        active: true
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: 2,
                        name: 'Servicios a residentes',
                        items: [
                            {
                                title: 'Noticias',
                                subtitle: '',
                                active: true,
                                component: 'news',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Crear categoría de noticias',
                                        route: 'special_categories',
                                        active: this.getCompany().news.general_news
                                    },
                                    {
                                        id: 2,
                                        title: 'Noticias',
                                        route: 'news',
                                        active: this.getCompany().news.general_news
                                    },
                                    {
                                        id: 3,
                                        title: 'Videos',
                                        route: 'news_video',
                                        active: this.getCompany().news.video_news
                                    },
                                    {
                                        id: 4,
                                        title: 'Noticias Twit',
                                        route: 'news_headline',
                                        active: this.getCompany().news.twits_news
                                    },
                                    {
                                        id: 4,
                                        title: 'Lista de noticias públicas',
                                        route: 'news_public',
                                        active: this.getCompany().news.general_news
                                    },
                                    {
                                        id: 4,
                                        title: 'Lista de noticias inactivas',
                                        route: 'news_hidden',
                                        active: this.getCompany().news.general_news
                                    }
                                ]
                            },
                            {
                                title: 'Mensajería',
                                subtitle: '',
                                active: true,
                                component: 'message-icon',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Notificaciones push',
                                        route: 'notification',
                                        active: this.getCompany().notifications.push_notifications
                                    },
                                    {
                                        id: 2,
                                        title: 'Emails',
                                        route: 'email_historial',
                                        active: this.getCompany().messages.segment_mails
                                    },
                                    {
                                        id: 3,
                                        title: 'Whatsapp',
                                        route: 'massive_whatsapp',
                                        active: this.getCompany().notifications.whatsapp_messages
                                    },
                                    {
                                        id: 4,
                                        title: 'Plantillas',
                                        route: 'whatsapp_templates',
                                        active: this.getCompany().notifications.whatsapp_messages
                                    }
                                ]
                            },
                            {
                                title: 'Pagos',
                                subtitle: '',
                                active: this.getCompany().payments.admin_payments,
                                component: 'payments-icon',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Crear apartamento',
                                        route: 'location',
                                        active: this.getCompany().payments.admin_payments
                                    },
                                    {
                                        id: 2,
                                        title: 'Revisar pagos',
                                        route: 'configure_property',
                                        active: this.getCompany().payments.admin_payments
                                    },
                                    {
                                        id: 3,
                                        title: 'Método de pago',
                                        route: 'payment_methods',
                                        active: this.getCompany().payments.admin_payments
                                    },
                                    {
                                        id: 4,
                                        title: 'Estado de Pago',
                                        route: 'payments_status',
                                        selected: false,
                                        active: this.getCompany().payments.admin_payments
                                     }
                                ]
                            },
                            {
                                title: 'Encuestas',
                                subtitle: '',
                                active: true,
                                component: 'form-icon',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Crear encuesta',
                                        route: 'new_form',
                                        active: this.getCompany().forms.custom_forms
                                    },
                                    {
                                        id: 2,
                                        title: 'Resultados de encuestas',
                                        route: 'forms_index',
                                        active: this.getCompany().forms.custom_forms
                                    }
                                ]
                            },
                            {
                                title: 'Catálogo Emprendimientos',
                                subtitle: '',
                                active: true,
                                component: 'offer',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Crear publicación',
                                        route: 'offer_new',
                                        active: this.enabledItem(this.getCompany().offers)
                                    },
                                    {
                                        id: 2,
                                        title: 'Publicaciones creadas',
                                        route: 'offer',
                                        active: this.enabledItem(this.getCompany().offers)
                                    },
                                    {
                                        id: 3,
                                        title: 'Publicaciones ocultas',
                                        route: 'offer_hidden',
                                        active: this.enabledItem(this.getCompany().offers)
                                    },
                                    {
                                        id: 3,
                                        title: 'Categorías de publicaciones',
                                        route: 'category',
                                        active: this.enabledItem(this.getCompany().offers)
                                    },
                                ]
                            },
                            {
                                title: 'Fidelización',
                                subtitle: '',
                                active: this.getCompany().rewards.rewards,
                                component: 'reward',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Importar características',
                                        route: 'new_segments_data',
                                        active: this.getCompany().rewards.user_characteristics
                                    },
                                    {
                                        id: 2,
                                        title: 'Crear segmento',
                                        route: 'condition',
                                        active: this.getCompany().rewards.segments
                                    },
                                    {
                                        id: 3,
                                        title: 'Listado',
                                        route: 'reward',
                                        active: this.getCompany().rewards.rewards
                                    },
                                    {
                                        id: 4,
                                        title: 'Crear beneficio',
                                        route: 'offer_new',
                                        active: this.getCompany().rewards.rewards
                                    },
                                    // {
                                    //     id: 5,
                                    //     title: 'Geolocalización',
                                    //     route: 'users_geolocations',
                                    //     active: this.getCompany().rewards.rewards
                                    // }
                                ]
                            },
                            {
                                title: 'Directorio',
                                subtitle: '',
                                active: true,
                                component: 'directory-icon',
                                dropdown: false,
                                route: '',
                                sub_items:[]
                            },
                            {
                                title: 'Comunidad',
                                subtitle: '',
                                active: true,
                                component: 'community-icon',
                                dropdown: false,
                                route: '',
                                sub_items:[]
                            },
                            {
                                title: 'Contactos',
                                subtitle: '',
                                active: true,
                                component: 'contact-us-icon',
                                dropdown: false,
                                route: '',
                                sub_items:[]
                            },
                            {
                                title: 'Paquetería',
                                subtitle: '',
                                active: this.getCompany().parcels.parcels_delivery,
                                component: 'parcels-icon',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Gestionar paquetes',
                                        route: 'parcels_index',
                                        active: this.getCompany().parcels.parcels_delivery
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        id: 3,
                        name: 'Seguridad',
                        items: [
                            {
                                title: 'Accesos',
                                subtitle: '',
                                active: this.enabledItem(this.getCompany().access),
                                component: 'access',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Mapa de calor',
                                        route: 'dashboard_accesses',
                                        active: this.getCompany().access.user_access
                                    },
                                    {
                                        id: 2,
                                        title: 'Por locación',
                                        route: 'access',
                                        active: this.getCompany().access.user_access
                                    },
                                    {
                                        id: 3,
                                        title: 'Crear recepcionista (Counter)',
                                        route: 'counter_index',
                                        active: this.getCompany().access.counter
                                    },
                                    {
                                        id: 31,
                                        title: 'Logs de acciones de Counter',
                                        route: 'counter_logs',
                                        active: this.getCompany().access.counter
                                    },
                                    {
                                        id: 4,
                                        title: 'Crear QR - Vigilante virtual',
                                        route: 'virtual_guard_qr_generator',
                                        active: this.getCompany().access.virtual_guard
                                    },
                                    {
                                        id: 5,
                                        title: 'Imprimir QR',
                                        route: 'generate_qr',
                                        active: this.getCompany().access.counter
                                    },
                                    {
                                        id: 6,
                                        title: 'Dispositivos de acceso por usuario',
                                        route: 'access_devices',
                                        active: true
                                    },
                                    {
                                        id: 7,
                                        title: 'Reestablecer dispositivo',
                                        route: 'reset_user_devices',
                                        active: true
                                    },
                                    {
                                        id: 8,
                                        title: 'Invitaciones',
                                        route: 'invitations_index',
                                        selected: false,
                                        active: this.getCompany().invitations.admin_invitations
                                    }
                                ]
                            },
                            {
                                title: 'Alertas',
                                subtitle: '',
                                active: true,
                                component: 'clientinformation',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Accesos por día',
                                        route: 'alerts_index',
                                        active: this.getCompany().access.alerts
                                    },
                                    {
                                        id: 2,
                                        title: 'Usuario con múltiples dispositivos',
                                        route: 'alerts_device_index',
                                        active: this.getCompany().access.alerts
                                    }
                                ]
                            },
                            {
                                title: 'Reserva de espacios',
                                subtitle: '',
                                active: true,
                                component: 'spaces-reservation-icon',
                                dropdown: true,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Crear reserva a un usuario',
                                        route: 'booking_index',
                                        active: true
                                    },
                                    {
                                        id: 2,
                                        title: 'Cancelar reserva',
                                        route: 'cancel_booking',
                                        active: true
                                    },
                                    {
                                        id: 3,
                                        title: 'Reportes',
                                        route: 'reports',
                                        active: true
                                    },
                                    {
                                        id: 2,
                                        title: 'Crear recepcionista',
                                        route: 'counter_index',
                                        active: true
                                    }
                                ]
                            },
                            {
                                title: 'Alarmas',
                                active: this.getCompany().alarms.alarms,
                                component: 'alarm-icon',
                                dropdown: true,
                                selected: false,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Reportes',
                                        route: 'AlarmsIndex',
                                        selected: false,
                                        active: this.getCompany().alarms.alarms
                                    },

                                ]
                            },
                            {
                                title: 'Dispositivos',
                                active: this.getCompany().access.device_administration,
                                component: 'device-icon',
                                dropdown: true,
                                selected: false,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Crear dispositivo',
                                        route: 'new_device',
                                        selected: false,
                                        active: this.getCompany().access.device_administration
                                    },
                                    {
                                        id: 2,
                                        title: 'Listado de dispositivos',
                                        route: 'devices',
                                        selected: false,
                                        active: this.getCompany().access.device_administration
                                    },

                                ]
                            },
                            {
                                title: 'Invitaciones Empresariales',
                                active: this.getCompany().access.invitation_approved,
                                component: 'business-invitations-icon',
                                dropdown: true,
                                selected: false,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Tipos de Invitaciones',
                                        route: 'invitation_types',
                                        selected: false,
                                        active: this.getCompany().access.invitation_approved
                                    },
                                    {
                                        id: 2,
                                        title: 'Departamentos validadores',
                                        route: 'approval_departments',
                                        selected: false,
                                        active: this.getCompany().access.invitation_approved
                                    },
                                    {
                                        id: 3,
                                        title: 'Usuarios validadores',
                                        route: 'approved_users',
                                        selected: false,
                                        active: this.getCompany().access.invitation_approved
                                    },


                                ]
                            },
                        ]
                    },
                    {
                        id: 4,
                        name: 'Sistema de Gestión de Calidad',
                        items: [
                            {
                                title: 'Calendario de tareas',
                                subtitle: '',
                                active: this.getCompany().sgsst.general,
                                component: 'calendar-icon',
                                dropdown: this.getCompany().sgsst.general,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Ver calendario',
                                        route: 'work_calendar',
                                        active: true
                                    }
                                ]
                            },
                            {
                                title: 'Proveedores',
                                subtitle: '',
                                active: this.getCompany().sgsst.general,
                                component: 'providers-icon',
                                dropdown: this.getCompany().sgsst.general,
                                sub_items:[
                                    {
                                        id: 1,
                                        title: 'Crear proveedor',
                                        route: 'providers',
                                        active: true
                                    }
                                ]
                            },
                            {
                                title: 'Funcionarios',
                                subtitle: '',
                                active: false,
                                component: 'officials-icon',
                                dropdown: false,
                                route: '',
                                sub_items:[]
                            },
                            {
                                title: 'Censo',
                                subtitle: '',
                                active: false,
                                component: 'census-icon',
                                dropdown: false,
                                route: '',
                                sub_items:[]
                            },
                            {
                                title: 'Brigadistas',
                                subtitle: '',
                                active: false,
                                component: 'brigade-members-icon',
                                dropdown: false,
                                route: '',
                                sub_items:[]
                            },
                            {
                                title: 'Clasificación de residuos',
                                subtitle: '',
                                active: false,
                                component: 'waste-sorting-icon',
                                dropdown: false,
                                route: '',
                                sub_items:[]
                            }
                        ]
                    },
                    {
                        id: 5,
                        name: 'Reportes',
                        items: [
                            {
                                title: 'Usuarios',
                                subtitle: '',
                                active: true,
                                component: 'user-icon',
                                dropdown: true,
                                sub_items:[
                                  {
                                    id: 1,
                                    title: 'Usuarios registrados',
                                    route: 'users',
                                    active: true
                                  },
                                  {
                                    id: 2,
                                    title: 'Dashboard',
                                    route: 'users_charts',
                                    active: true
                                  }
                                ]
                            },
                            {
                                title: 'Accesos',
                                subtitle: '',
                                active: true,
                                component: 'access',
                                dropdown: false,
                                route: 'reports',
                                sub_items:[]
                            },
                            {
                                title: 'Reserva de espacios',
                                subtitle: '',
                                active: true,
                                component: 'spaces-reservation-icon',
                                dropdown: false,
                                route: 'reports',
                                sub_items:[]
                            },
                            {
                                title: 'Beneficios',
                                subtitle: '',
                                active: false,
                                component: 'offer',
                                dropdown: false,
                                route: '',
                                sub_items:[]
                            }
                        ]
                    }
                ],
            }
        },
        computed: {
            displaySections() {
                if (this.getUserType() !== 'Counter') return this.sections;
                const configSection = this.sections[0];
                const usuariosItem = configSection && configSection.items.find(i => i.title === 'Usuarios');
                const paginaPrincipal = {
                    title: 'Página Principal',
                    subtitle: 'Ir al inicio',
                    active: true,
                    route: 'main_menu_page',
                    dropdown: false,
                    component: 'home-icon',
                    sub_items: []
                };
                const counterUsuariosItem = usuariosItem ? {
                    ...usuariosItem,
                    sub_items: [
                        { id: 2, title: 'Editar información de usuario', route: 'edit_user', active: true }
                    ]
                } : null;
                return [{
                    id: 1,
                    name: 'Inicio',
                    items: [paginaPrincipal, counterUsuariosItem].filter(Boolean)
                }];
            }
        },
        mounted(){
            this.charged = true
        },
        methods: {
            enabledItem(company_object){
                var visible = Object.entries(company_object).filter(([key, value]) => value !== "" && value === true).length > 0 ? true : false
                return visible
            }
        }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/menu_page/MainMenuPage.vue